export const URL = 'https://entrateinerin-back-production.up.railway.app'
export const MAP_BOX_KEY =
  process.env.REACT_APP_MAP_BOX_KEY || 'pk.eyJ1IjoianVyaXA4OSIsImEiOiJjbGFjb21jamwwY2UwM3BydHJiOWpqdW4xIn0.0M_uGjWX3WakTXhFzjmlBw';
export const CLOUD_KEY = process.env.REACT_APP_CLOUD_KEY || 'dmk9xo60f';
